module.exports = __webpack_public_path__ + "static/media/upgrade-bg.d0e1e84f.png";